module Core {
    export enum TypologiesTypes {
        Label = 1,
        Marqueur = 2,
        Autre = 3
    }
}